import defineComponent from 'flight';

function Toggle() {
    this._toggle = function() {
        this.trigger(document, 'ui:toggle:' + this._context, {
            expand: !this.$node.hasClass('active')
        });
    };

    this._updateState = function(evt, data) {
        if (data.expand) {
            this.$node.addClass('active');
        } else {
            this.$node.removeClass('active');
        }
    };

    this._updateStateForAnchor = function() {
        const anchor =
            document.location.hash && document.location.hash.length > 0
                ? document.location.hash.substring(1)
                : null;
        if (!anchor) {
            return;
        }
        const activate = this.$node.data('toggle-open-for-anchor') === anchor;
        if (!activate) {
            return;
        }
        this.trigger(document, 'ui:toggle:' + this._context, {
            expand: true
        });
    };

    this.after('initialize', function() {
        this._context = this.$node.data('toggle');
        this.on('click', this._toggle);
        this.on(document, 'ui:toggle:' + this._context, this._updateState);
        this._updateStateForAnchor();
    });
}

export default defineComponent.component(Toggle);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/toggle.js